import { render, staticRenderFns } from "./TasksList.vue?vue&type=template&id=7c4a7bce&scoped=true"
import script from "./TasksList.vue?vue&type=script&lang=js"
export * from "./TasksList.vue?vue&type=script&lang=js"
import style0 from "./TasksList.vue?vue&type=style&index=0&id=7c4a7bce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4a7bce",
  null
  
)

export default component.exports